import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { MessageCircle, ArrowUp } from "lucide-react";
import { CONTACT } from "../data/site";
import { scrollTop } from "../lib/smooth";
import { useContents } from "../hooks/useContents";

export const Floating = () => {
  const [showTop, setShowTop] = useState(false);
  const c = useContents();
  const wa = `https://wa.me/${c("contact_whatsapp", "393208978227")}`;
  useEffect(() => {
    const fn = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", fn, { passive: true });
    return () => window.removeEventListener("scroll", fn);
  }, []);

  return (
    <>
      <a
        href={wa}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-button"
        aria-label="Scrivici su WhatsApp"
        className="hidden md:flex fixed bottom-6 right-6 z-40 w-14 h-14 items-center justify-center rounded-full bg-[#25D366] text-black shadow-2xl transition-transform duration-300 hover:scale-110"
      >
        <MessageCircle size={26} strokeWidth={2.2} />
      </a>

      <AnimatePresence>
        {showTop && (
          <motion.button
            data-testid="back-to-top-button"
            aria-label="Torna su"
            onClick={() => scrollTop(false)}
            className="fixed bottom-[84px] right-4 md:bottom-24 md:right-7 z-40 w-11 h-11 flex items-center justify-center bg-card border border-steel text-metal hover:border-forest-glow hover:text-forest-glow transition-colors"
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 12 }}
          >
            <ArrowUp size={18} />
          </motion.button>
        )}
      </AnimatePresence>

      <div data-testid="mobile-sticky-cta" className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-graphite/95 backdrop-blur-md border-t border-steel p-3 flex gap-2">
        <Link to="/contatti" data-testid="mobile-sticky-cta-quote" className="btn-primary flex-1 !py-3 text-center">
          Richiedi preventivo
        </Link>
        <a
          href={wa}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="mobile-sticky-cta-whatsapp"
          className="btn-ghost !py-3 !px-4 flex items-center gap-2"
          aria-label="WhatsApp"
        >
          <MessageCircle size={17} className="text-[#25D366]" />
          WhatsApp
        </a>
      </div>
    </>
  );
};
